// Sekmeye dönüşte (focus + visibilitychange) liste tazeleme: iki olay çoğunlukla birlikte gelir —
// uçuşta bir istek varken yenisi açılmaz; efekt temizlendikten sonra (müşteri değişti, sayfa
// kapandı) gelen yanıt yazılmaz. Hata sessizce yutulur (mevcut liste korunur).

export interface FocusRefetch {
  trigger: () => void;
  cancel: () => void;
}

export function createFocusRefetch<T>(
  load: () => Promise<T>,
  apply: (value: T) => void,
  isHidden: () => boolean,
): FocusRefetch {
  let cancelled = false;
  let inFlight = false;
  return {
    trigger() {
      if (cancelled || inFlight || isHidden()) return;
      inFlight = true;
      load()
        .then((v) => {
          if (!cancelled) apply(v);
        })
        .catch(() => undefined)
        .finally(() => {
          inFlight = false;
        });
    },
    cancel() {
      cancelled = true;
    },
  };
}
